import { Box, ListItemButton, css, styled } from '@mui/material'
import getPaletteColor from '../../../utils/getPaletteColor'

export const CategoryListComponent = styled(ListItemButton)(
  ({ theme }) => css`
    border-bottom: 1px solid ${getPaletteColor(theme, 'divider')};
  `
)

export const CategoryHeader = styled(Box)(
  () => css`
    padding-left: 16px;
  `
)
